import React from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const ActionBar = ({
                       search,
                       handleSearch,
                       filter,
                       handleFilterChange,
                       setupPage
                   }) => {
    const options = [
        { value: "all", title: "All" },
        { value: "active", title: "Active" },
        { value: "in_active", title: "In Active" },
        { value: "show_on_menu", title: "Show On Menu" },
    ]
    return (
        <Grid container spacing={2} alignItems="center">
            {/* Setup Landing Page Button */}
            <Grid item xs={12} md={2}>
                <Typography variant="h6" gutterBottom>
                    <Button
                        startIcon={<AddIcon />}
                        variant="contained"
                        color="primary"
                        onClick={setupPage}
                    >
                        Setup LandingPage
                    </Button>
                </Typography>
            </Grid>

            {/* Search Field */}
            <Grid item xs={12} md={5}>
                <TextField
                    fullWidth
                    size="small"
                    label="Search by PageId, Title, Slug"
                    variant="outlined"
                    value={search}
                    onChange={handleSearch}
                />
            </Grid>

            {/* Filter Dropdown */}
            <Grid item xs={12} md={2}>
                <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={filter}
                        onChange={handleFilterChange}
                        label="Status"
                    >
                        {options.map((e) => <MenuItem value={e.value}>{e.title}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default ActionBar;
